import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import DateField from 'containers/components/Fields/Date';
import { getDateFormatPlaceholder } from 'utils/dates';
import { normalizeLineDateValue } from 'utils/fm/fields';

/**
 * Table cell adapter for extra-field date columns.
 * Keeps the CustomCell contract (value + onChange) while using EntityCrud DateField.
 */
const ProductLineDateCell = memo(
    ({ value, onChange, isEnriched = false, error, showMandatoryMark = false }) => {
        const dateValue = useMemo(() => normalizeLineDateValue(value), [value]);

        const handleChange = useCallback(
            (newDate) => {
                onChange?.(normalizeLineDateValue(newDate));
            },
            [onChange],
        );

        return (
            <DateField
                className="fm-product-line-date-cell"
                value={dateValue}
                onChange={handleChange}
                isEnriched={isEnriched}
                error={error}
                placeholder={showMandatoryMark ? `* ${getDateFormatPlaceholder()}` : undefined}
            />
        );
    },
);

ProductLineDateCell.displayName = 'ProductLineDateCell';
ProductLineDateCell.propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    isEnriched: PropTypes.bool,
    onChange: PropTypes.func,
    showMandatoryMark: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

export default ProductLineDateCell;
